import { render } from "./RegisterWidget.vue?vue&type=template&id=adcefd12&scoped=true"
import script from "./RegisterWidget.vue?vue&type=script&lang=js"
export * from "./RegisterWidget.vue?vue&type=script&lang=js"

import "./RegisterWidget.vue?vue&type=style&index=0&id=adcefd12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adcefd12"],['__file',"src/components/RegisterWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "adcefd12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('adcefd12', __exports__)) {
    api.reload('adcefd12', __exports__)
  }
  
  module.hot.accept("./RegisterWidget.vue?vue&type=template&id=adcefd12&scoped=true", () => {
    api.rerender('adcefd12', render)
  })

}


export default __exports__